var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.796 9.233l-.452 1.957 2.099-.807.426.159c.652.243 1.371.38 2.131.38 3.141 0 5.467-2.266 5.467-4.8 0-2.536-2.326-4.8-5.467-4.8-3.141 0-5.467 2.264-5.467 4.8 0 .976.333 1.892.92 2.663l.343.448zm-1.296.28A5.566 5.566 0 01.333 6.12c0-3.314 2.985-6 6.667-6s6.667 2.686 6.667 6-2.985 6-6.667 6a7.294 7.294 0 01-2.55-.455l-2.846 1.095a.533.533 0 01-.712-.618l.608-2.63z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.121a.667.667 0 11-1.333 0 .667.667 0 011.333 0z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.133 6.121a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-.8.667a.667.667 0 100-1.334.667.667 0 000 1.334z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 6.121a.667.667 0 11-1.334 0 .667.667 0 011.334 0z",
    fill: "#575757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 6.121a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-.8.667a.667.667 0 100-1.334.667.667 0 000 1.334z",
    fill: "#575757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 6.121a.667.667 0 11-1.333 0 .667.667 0 011.333 0z",
    fill: "#575757"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.467 6.121a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-.8.667a.667.667 0 100-1.334.667.667 0 000 1.334z",
    fill: "#575757"
  })));
}

export default SvgAnswer;